export interface IHighlightsProps {
    highlights: string[];
}

export const Highlights = (props: IHighlightsProps): JSX.Element => {
    return (
        <>
            {(props?.highlights || []).map((highlight, index) => <span key={`${index}-${highlight}`} className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1">{highlight}</span>)}
        </>
    )
}

